import React, { useState } from "react";
import me from "../assets/images/me.jpg";
import Typed from "react-typed";
import { FaMousePointer } from "react-icons/fa";

const Me = () => {
  const [time, setTime] = useState(false);

  const handleClick = () => {
    setTime(true);
  };

  return (
    <div
      onClick={handleClick}
      className="lg:min-h-[70vh] flex  justify-between min-h-full flex-col lg:flex-row items-center w-[100vw] bg-[#171717]"
    >
      <div>
        <img
          src={me}
          className="lg:w-[400px] p-4 lg:ml-20  rounded-lg"
          alt=""
        />
      </div>
      <div className="text-lg lg:w-4/12 p-4 mx-auto">
        {!time && (
          <div>
            <h2 className="text-3xl  capitalize btn-outline  btn btn-secondary text-white">
              <span className="relative">Click it</span>
            </h2>
            <FaMousePointer className="indicate  text-3xl top-[70%] left-[55%] lg:top-[40%] absolute" />
          </div>
        )}
        {time && (
          <Typed
            style={{ padding: "15px" }}
            strings={[
              `Hi,I'm Kibria. I’m a web developer . I use Javascript, NodeJs
                 to create high-end interactive experiences and products. I
                  currently working in my personal e-commerce website for my business.
                  Recently I completed my web development course in Programming hero.
                  Some software engineer of Phero make my better in web development universe.`,
            ]}
            typeSpeed={20}
            loopCount
          />
        )}
      </div>
    </div>
  );
};

export default Me;
